const { ACCESS_RIGHTS } = require('./access');

/**
 * Use like toEnum(...["ONE", "TWO"]) to get
 * a constant back that is immutable and only has
 * those values.
 * @public
 * @template {Array<string>} T
 * @param {T} enumerated A list of elements to enumerate
 * @returns {{ [V in T[*]]: V }}
 */
const toEnum = (...enumerated) => {
  const myEnum = enumerated.reduce((acc, curr) => {
    acc[curr] = curr;
    return acc;
  }, {});

  return Object.freeze(myEnum);
};

const permission = (feature, accessRights = ACCESS_RIGHTS) => ({ [feature]: accessRights });

const permissionsToRoleMap = permissionSet => {
  return Object.entries(permissionSet || {}).reduce((acc, [role, permissions]) => {
    Object.entries(permissions).forEach(([permissionName, accessRights]) => {
      if (!acc[permissionName]) {
        acc[permissionName] = {};
        accessRights.forEach((accessRight) => {
          acc[permissionName][accessRight] = [role];
        });
      } else {
        accessRights.forEach((accessRight) => {
          if (acc[permissionName][accessRight]) {
            acc[permissionName][accessRight].push(role);
          } else {
            acc[permissionName][accessRight] = [role];
          }
        });
      }
    });
    return acc;
  }, {});
};

module.exports = {
  toEnum,
  permission,
  permissionsToRoleMap,
};
